import { DepositSurveyService } from "@modules/+new/payments/features/deposit-survey/infrastructure/deposit-survey.service";
import { NgModule } from "@angular/core";

@NgModule({
	providers: [DepositSurveyService]
})
export class DepositSurveyModule {}
